<div class="plain-layout-container">
  <router-outlet></router-outlet>
</div>
